import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRouteLogin = ({
  isConnected,
  component: Component,
  // eslint-disable-next-line no-useless-rename
  users: users,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props =>
        !isConnected ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/admin/home', state: { from: props.location } }}
          />
        )
      }
    />
  );
};
export default PrivateRouteLogin;
